import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPaginationModule } from 'ngx-pagination';
import { SQLite } from '@awesome-cordova-plugins/sqlite/ngx';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { MdcFormComponent } from './mdc-form/mdc-form.component';
import { TermsPolicyComponent } from './terms-policy/terms-policy.component';
import { StepIntroComponent } from './mdc-form/step/step-intro/step-intro.component';
import { StepSectionIComponent } from './mdc-form/step/step-section-i/step-section-i.component';
import { StepSectionIIComponent } from './mdc-form/step/step-section-ii/step-section-ii.component';
import { StepSectionIIIComponent } from './mdc-form/step/step-section-iii/step-section-iii.component';
import { StepSectionIVComponent } from './mdc-form/step/step-section-iv/step-section-iv.component';
import { StepSectionVComponent } from './mdc-form/step/step-section-v/step-section-v.component';
import { StepSectionVIComponent } from './mdc-form/step/step-section-vi/step-section-vi.component';
import { StepSectionVIIIComponent } from './mdc-form/step/step-section-vii/step-section-vii.component';
import { StepEndComponent } from './mdc-form/step/step-end/step-end.component';
import { StepVerificationComponent } from './mdc-form/step/step-verification/step-verification.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptorService } from './shared/auth/auth-interceptor.service';
import { EmailIconComponent } from './components/icons/email-icon/email-icon.component';
import { CaptchaIconComponent } from './components/icons/captcha-icon/captcha-icon.component';
import { QrcodeIconComponent } from './components/icons/qrcode-icon/qrcode-icon.component';
import { SmsIconComponent } from './components/icons/sms-icon/sms-icon.component';
import { SuccessfulIconComponent } from './components/icons/successful-icon/successful-icon.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormOfflineComponent } from './form-offline/form-offline.component';
import { BackComponent } from './components/back/back.component';
import { DashboardComponent } from './dashboard/dashboard.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    FooterComponent,
    HomeComponent,
    DashboardComponent,
    MdcFormComponent,
    TermsPolicyComponent,
    StepIntroComponent,
    StepSectionIComponent,
    StepSectionIIComponent,
    StepSectionIIIComponent,
    StepSectionIVComponent,
    StepSectionVComponent,
    StepSectionVIComponent,
    StepSectionVIIIComponent,
    StepEndComponent,
    StepVerificationComponent,
    EmailIconComponent,
    CaptchaIconComponent,
    QrcodeIconComponent,
    SmsIconComponent,
    SuccessfulIconComponent,
    FormOfflineComponent,
    BackComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgbModule,
    FormsModule,
    NgSelectModule,
    NgxPaginationModule,
    CarouselModule,
    NgxPaginationModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'mdc-form', component: MdcFormComponent },
      { path: 'dashboard', component: DashboardComponent },
      {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
      },
      { path: 'form-offline', component: FormOfflineComponent },
      { path: '**', redirectTo: '' }
    ])
  ],
  providers: [SQLite, HttpClient, { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
